export const chargeServicesDrawer = {
  title: "Leistungen und Services",
  closeAria: "Schließen",
  subtitle: {
    catalog: "Wiederverwendbarer Katalog für Ihre Rechnungen",
    select: "Wählen Sie die Positionen aus, die Sie hinzufügen möchten",
  },
  searchPlaceholder: "Service suchen…",
  createService: "Service anlegen",
  loading: "Services werden geladen…",
  empty: "Sie haben noch keine Services. Legen Sie den ersten an.",
  item: {
    vat: "MwSt. {vat} %",
    edit: "Bearbeiten",
    delete: "Löschen",
  },
  footer: {
    selected: "{count} ausgewählt | {count} ausgewählt",
    createInvoice: "Rechnung damit erstellen",
    addToInvoice: "Zur Rechnung hinzufügen",
  },
  form: {
    editTitle: "Service bearbeiten",
    newTitle: "Neuer Service",
    subtitle: "Wiederverwendbare Position für Ihre Rechnungen",
    photoLabel: "Foto",
    optional: "optional",
    uploadPhoto: "Hochladen",
    nameLabel: "Name",
    namePlaceholder: "z. B. Endreinigung",
    categoryLabel: "Kategorie",
    categoryPlaceholder: "z. B. Reinigung",
    priceLabel: "Preis",
    vatLabel: "MwSt.",
    descriptionLabel: "Beschreibung",
    descriptionPlaceholder: "Details, die auf der Rechnung erscheinen",
    cancel: "Abbrechen",
    save: "Änderungen speichern",
    create: "Service anlegen",
  },
  toasts: {
    loadError: "Die Services konnten nicht geladen werden.",
    photoError: "Das Foto konnte nicht hochgeladen werden.",
    updated: "Service aktualisiert.",
    created: "Service angelegt.",
    saveError: "Der Service konnte nicht gespeichert werden.",
    deleteError: "Löschen nicht möglich.",
  },
  confirmDelete: '"{name}" aus dem Katalog löschen?',
};
